import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Conditional } from '../../../common';
import cx from 'classnames';
import styles from './style.module.scss';
export const ReadonlyValue = ({ label, value, required = true, notation }) => {
    return (_jsxs("div", { className: styles['read-only-value'], children: [_jsx("span", { className: "cat-u-theme-typography-label-lg", children: label }), _jsx(Conditional, { test: required, children: _jsx("span", { className: cx(styles['required-field'], 'cat-u-theme-typography-footnote'), children: notation }) }), _jsx("p", { className: "cat-u-theme-typography-label-lg u-color--ExtraDarkGray mb-0", children: value })] }));
};
